import flagsmithVue from 'flagsmith-vue';
import { createApp } from 'vue';

import { createHttpClient, httpClient } from '@abaninja/util-http-client';

import 'unfonts.css';
import 'vuetify/styles';

import App from './App.vue';
import { i18n } from './plugins/i18n';
import { pinia } from './plugins/pinia';
import { initSentry } from './plugins/sentry';
import { unhead } from './plugins/unhead';
import { createVeeValidate } from './plugins/vee-validate';
import { vuetify } from './plugins/vuetify';
import router from './router';
import './scss/base.scss';

const app = createApp(App);

// init plugins
app.use(router);
app.use(vuetify);
app.use(i18n);
app.use(unhead);
app.use(pinia);

app.use(flagsmithVue, {
  api: import.meta.env.VITE_FLAGSMITH_API,
  cacheFlags: true,
  enableAnalytics: true,
  enableLogs: import.meta.env.VITE_FLAGSMITH_ENABLE_LOGS === 'true',
  environmentID: import.meta.env.VITE_FLAGSMITH_ENVIRONMENT_ID,
});

createVeeValidate();

const { requestBearerTokenInterceptorId } = createHttpClient({
  baseURL: import.meta.env.VITE_API_URL,
});

httpClient.interceptors.request.eject(requestBearerTokenInterceptorId);

httpClient.interceptors.request.use((config) => {
  // do not prefix basics with admin-tool
  config.headers['X-Abaninja-Auth'] = sessionStorage.getItem('hash');

  return { ...config };
});

initSentry(app, router);

app.mount('#root');
